import { connectHook } from '../../connect-hook.js';
import { Number } from './number.js';
import { useNumber } from './number-hook.js';

export default connectHook(Number, useNumber);
